// extracted by mini-css-extract-plugin
module.exports = {"confirmRemovePackListings":"styles_confirmRemovePackListings__1EXVD","msg":"styles_msg__3kMzm"};